import { render } from "./KRPlacardSkeleton.vue?vue&type=template&id=7debfd50&scoped=true"
import script from "./KRPlacardSkeleton.vue?vue&type=script&lang=js"
export * from "./KRPlacardSkeleton.vue?vue&type=script&lang=js"

import "./KRPlacardSkeleton.vue?vue&type=style&index=0&id=7debfd50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7debfd50"

export default script